import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'Menu',
        isTitle: true
    },
    {
        id: 2,
        label: 'Dashboard',
        icon: 'bx bx-home-circle',
        link: '/',

    },
    {
        id: 2,
        label: 'Locations ',
        icon: 'bx bx-map-pin',
        link: '/locations',
    },
    {
        id: 2,
        label: 'Users',
        icon: 'bx bx-user-check',
        link: '/users',
    },
    {
        id: 3,
        label: 'Validation Partners',
        icon: 'bx bx-user',
        link: '/validationPartner',
    },
    {
        id: 4,
        label: 'Parkings',
        icon: 'bx bx-car',
        link: '/parkings',
    },
    // {
    //     id: 5,
    //     label: 'Transactions',
    //     icon: 'bx bx-list-ol',
    //     link: '/transaction',
    // },
    // {
    //     id: 2,
    //     label: 'DB Users',
    //     icon: 'mdi mdi-database-lock-outline',
    //     link: '/db-users',
    // },
    // {
    //     id: 2,
    //     label: 'API Generation',
    //     icon: 'bx bx-code-alt',
    //     link: '/api',
    // },
    {
        id: 9,
        label: 'System Settings',
        icon: 'bx bx-cog',
        link: '/settings',

        subItems: [
            {
                id: 13,
                label: 'Payment Types',
                link: '/paymentTypes',
                parentId: 9
            },
            // {
            //     id: 13,
            //     label: 'Transactions',
            //     link: '/point-transactions',
            //     parentId: 9
            // },
        ]
    },

 
];

